import { List } from 'immutable';
import LanguageUtils from '../../../utils/LanguageUtils';
import ValidationUtils, { ValidationConfig } from '../../../utils/validationUtils';
import ValidationModel from '../../../utils/validationModel';
import { ensure } from '../../../utils/arrayUtils';
import CancellationRule from '../../../interfaces/output/cancellationRule';

const messages = {
    requiredFields: LanguageUtils.createMessage('Validation error general'),
    outOfRange: LanguageUtils.createMessage('Value out of range'),
    wrongFormat: LanguageUtils.createMessage('Wrong time format')
};

export default class CancellationRuleStep1Validation extends ValidationUtils {
    static validateInputString(inputString?: string, options?: ValidationConfig): boolean {
        return this.validateInputStringLength(inputString, options);
    }

    static validClock(inputClock: string | undefined): boolean {
        return this.validateInputStringClock(inputClock);
    }

    static validateCancellationRuleForm(cancellationRule: CancellationRule): ValidationModel {
        const validationModel = {
            validationMessages: List(),
            isValid: true
        } as ValidationModel;
        const {
            cancellationType,
            priorityType,
            priorityRank,
            toDaysBeforeLoadingDate,
            fromLoadingHours,
            toLoadingHours,
            toHourLimit,
            fromHourLimit
        } = cancellationRule;

        const requiredFields =
            this.validateInputNumber(cancellationType?.id) && this.validateInputNumber(priorityType?.id) && this.validateInputNumber(priorityRank) &&
            this.validateInputNumber(toDaysBeforeLoadingDate) && this.validateInputString(fromLoadingHours) && this.validateInputString(toLoadingHours) &&
            this.validateInputString(toHourLimit);

        if(!requiredFields) {
            validationModel.isValid = false;
            validationModel.validationMessages = ensure(validationModel.validationMessages).push(messages.requiredFields);
        }

        const acceptedFormatFromLoadingHours = fromLoadingHours ? this.validClock(fromLoadingHours) : true;
        const acceptedFormatToLoadingHours = toLoadingHours ? this.validClock(toLoadingHours) : true;
        const acceptedFormatToHourLimit = toHourLimit ? this.validClock(toHourLimit) : true;
        const acceptedFormatFromHourLimit = fromHourLimit ? this.validClock(fromHourLimit) : true;

        if(!acceptedFormatFromLoadingHours || !acceptedFormatToLoadingHours || !acceptedFormatToHourLimit || !acceptedFormatFromHourLimit) {
            validationModel.isValid = false;
            validationModel.validationMessages = ensure(validationModel.validationMessages).push(messages.wrongFormat);
        }

        const runFromLoadingMonthDay =
            cancellationRule.fromLoadingMonthDay ? this.numberIsInInterval(cancellationRule.fromLoadingMonthDay, 1, 31) : true;

        const runToLoadingMonthDay =
            cancellationRule.toLoadingMonthDay ? this.numberIsInInterval(cancellationRule.toLoadingMonthDay, 1, 31) : true;

        if(!runFromLoadingMonthDay || !runToLoadingMonthDay) {
            validationModel.isValid = false;
            validationModel.validationMessages = ensure(validationModel.validationMessages).push(messages.outOfRange);
        }

        return validationModel;
    }
}
